import { render, staticRenderFns } from "./taxon-message.vue?vue&type=template&id=300d7d6c&"
import script from "./taxon-message.vue?vue&type=script&lang=js&"
export * from "./taxon-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports